import { LeadAgentLeadStateType } from '@/Mapper/LeadAgentLeadStateType';
import { LeadAgentLeadStageType } from '@/Mapper/LeadAgentLeadStageType';
import { LeadStateType } from '@/Mapper/LeadStateType';
import { LeadStageType } from '@/Mapper/LeadStageType';

const leadAgentMappingStore = (apiServices => ({
  strict: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state: {
    lam: {},
    lead: {},
    notes: [],
    files: [],
    contactpreferences: {},
  },
  mutations: {
    setLeadInfo: (state, leadInfoObj) => {
      state.lead = leadInfoObj; // eslint-disable-line no-param-reassign
    },
    setLeadAgentMapping: (state, lamObj) => {
      state.lam = lamObj; // eslint-disable-line no-param-reassign
    },
    setFiles: (state, files) => {
      state.files = files && Array.isArray(files) // eslint-disable-line no-param-reassign
        ? files
        : [];
    },
    pushFile: (state, fileObj) => {
      if (!state.files) state.files = []; // eslint-disable-line no-param-reassign
      state.files.push(fileObj);
    },
    setNotes: (state, notes) => {
      state.notes = notes && Array.isArray(notes) // eslint-disable-line no-param-reassign
        ? notes
        : [];
    },
    pushNote: (state, noteObj) => {
      if (!state.notes) state.notes = []; // eslint-disable-line no-param-reassign
      state.notes.push(noteObj);
    },
    setLeadContactPreference: (state, contactPreferenceObj) => {
      state.contactpreferences = contactPreferenceObj; // eslint-disable-line no-param-reassign
    },
  },
  actions: {
    async loadLeadAgentMapping(context, payload) {
      return apiServices.oa.leadAgent.getLam(payload.agentKey, payload.leadKey, payload.data)
        .then((data) => {
          context.commit('setLeadInfo', data.leadinfo);
          context.commit('setLeadAgentMapping', data.leadagentmappingsinfo[0]);
          context.commit('setNotes', data.leadagentmappingsinfo[0].notes);
          context.commit('setLeadContactPreference', data.leadinfo.contactpreference);
        });
    },
    async updateLeadAgentMapping(context, payload) {
      return apiServices.oa.leadAgent.update(payload.data, payload.lamid)
        .then((updatedLam) => {
          context.commit('setLeadAgentMapping', updatedLam);
        });
    },
    async getAgentUploadedFiles(context, payload) {
      return apiServices.oa.lead.getAgentUploadedFiles(payload)
        .then((files) => {
          context.commit('setFiles', files);
        });
    },
    async deleteUploadedFile(context, payload) {
      return apiServices.oa.lead.deleteUploadedFile(payload)
      .then((res) => {
        console.log("***** store file deletd", res);
      });
    },
    async updateLeadStage(context, payload) {
      return apiServices.oa.lead.updateLeadStage(payload.data, payload.leadkey)
        .then((leadInfo) => {
          context.commit('setLeadInfo', leadInfo);
        });
    },
    async uploadFile(context, form) {
      return apiServices.oa.lead.uploadFile(form)
        .then((file) => {
          context.commit('pushFile', file);
        });
    },
  },
  getters: {
    lamIsOnHoldIgnoredLead: state => state.lam.onhold === 1 && state.lam.onholdcategoryid === 9,
    lamIsActive: state => state.lam.statetypeid === LeadAgentLeadStateType.Active
      && state.lead.leadstateid === LeadStateType.Open,
    lamIsLost: state => state.lam.statetypeid === LeadAgentLeadStateType.Lost
      || state.lead.leadstateid === LeadStateType.Lost,
    lamIsPassedBack: state => state.lam.statetypeid === LeadAgentLeadStateType.Closed
      && state.lam.leaddeclinedreason === 'Give back to OpenAgent',
    lamIsClosedCloseLead: state => state.lam.statetypeid === LeadAgentLeadStateType.Closed
      && state.lam.leaddeclinedreason !== 'Give back to OpenAgent',
    lamIsClosed: state => state.lam.statetypeid === LeadAgentLeadStateType.Closed,
    lamIsOnHold: state => state.lead.leadstateid === LeadStateType.Open
      && state.lam.statetypeid === LeadAgentLeadStateType.On_Hold,
    lamStageIsReferred: state => state.lam.stagetypeid === LeadAgentLeadStageType.Referred,
    lamStageIsEqualOrMoreThanReferred: state => [
      LeadAgentLeadStageType.Referred,
      LeadAgentLeadStageType.Viewed,
      LeadAgentLeadStageType.Attempted,
      LeadAgentLeadStageType.Contacted_Vendor,
      LeadAgentLeadStageType.Appraised,
      LeadAgentLeadStageType.Appointed,
      LeadAgentLeadStageType.Listed,
    ].includes(state.lam.stagetypeid),
    lamStageIsViewed: state => state.lam.stagetypeid === LeadAgentLeadStageType.Viewed,
    lamStageIsLessThanViewed: state => [
      LeadAgentLeadStageType.Shown_To_Vendor,
      LeadAgentLeadStageType.Shortlisted,
      LeadAgentLeadStageType.Referred,
    ].includes(state.lam.stagetypeid),
    lamStageIsEqualOrMoreThanViewed: state => [
      LeadAgentLeadStageType.Viewed,
      LeadAgentLeadStageType.Attempted,
      LeadAgentLeadStageType.Contacted_Vendor,
      LeadAgentLeadStageType.Appraised,
      LeadAgentLeadStageType.Appointed,
      LeadAgentLeadStageType.Listed,
    ].includes(state.lam.stagetypeid),
    lamStageIsAttempted: state => state.lam.stagetypeid === LeadAgentLeadStageType.Attempted,
    lamStageIsLessThanAttempted: state => [
      LeadAgentLeadStageType.Shown_To_Vendor,
      LeadAgentLeadStageType.Shortlisted,
      LeadAgentLeadStageType.Referred,
      LeadAgentLeadStageType.Viewed,
    ].includes(state.lam.stagetypeid),
    lamStageIsEqualOrMoreThanAttempted: state => [
      LeadAgentLeadStageType.Attempted,
      LeadAgentLeadStageType.Contacted_Vendor,
      LeadAgentLeadStageType.Appraised,
      LeadAgentLeadStageType.Appointed,
      LeadAgentLeadStageType.Listed,
    ].includes(state.lam.stagetypeid),
    lamStageIsContacted: state => state.lam.stagetypeid === LeadAgentLeadStageType.Contacted_Vendor,
    lamStageIsLessThanContacted: state => [
      LeadAgentLeadStageType.Shown_To_Vendor,
      LeadAgentLeadStageType.Shortlisted,
      LeadAgentLeadStageType.Referred,
      LeadAgentLeadStageType.Viewed,
      LeadAgentLeadStageType.Attempted,
    ].includes(state.lam.stagetypeid),
    lamStageIsEqualOrMoreThanContacted: state => [
      LeadAgentLeadStageType.Contacted_Vendor,
      LeadAgentLeadStageType.Appraised,
      LeadAgentLeadStageType.Appointed,
      LeadAgentLeadStageType.Listed,
    ].includes(state.lam.stagetypeid),
    lamStageIsAppraised: state => state.lam.stagetypeid === LeadAgentLeadStageType.Appraised,
    lamStageIsLessThanAppraised: state => [
      LeadAgentLeadStageType.Shown_To_Vendor,
      LeadAgentLeadStageType.Shortlisted,
      LeadAgentLeadStageType.Referred,
      LeadAgentLeadStageType.Viewed,
      LeadAgentLeadStageType.Attempted,
      LeadAgentLeadStageType.Contacted_Vendor,
    ].includes(state.lam.stagetypeid),
    lamStageIsEqualOrMoreThanAppraised: state => [
      LeadAgentLeadStageType.Appraised,
      LeadAgentLeadStageType.Appointed,
      LeadAgentLeadStageType.Listed,
    ].includes(state.lam.stagetypeid),
    lamStageIsAppointed: state => state.lam.stagetypeid === LeadAgentLeadStageType.Appointed,
    lamStageIsLessThanAppointed: state => [
      LeadAgentLeadStageType.Shown_To_Vendor,
      LeadAgentLeadStageType.Shortlisted,
      LeadAgentLeadStageType.Referred,
      LeadAgentLeadStageType.Viewed,
      LeadAgentLeadStageType.Attempted,
      LeadAgentLeadStageType.Contacted_Vendor,
      LeadAgentLeadStageType.Appraised,
    ].includes(state.lam.stagetypeid),
    lamStageIsEqualOrMoreThanAppointed: state => [
      LeadAgentLeadStageType.Appointed,
      LeadAgentLeadStageType.Listed,
    ].includes(state.lam.stagetypeid),
    lamStageIsListed: state => state.lam.stagetypeid === LeadAgentLeadStageType.Listed,
    lamStageIsLessThanListed: state => [
      LeadAgentLeadStageType.Shown_To_Vendor,
      LeadAgentLeadStageType.Shortlisted,
      LeadAgentLeadStageType.Referred,
      LeadAgentLeadStageType.Viewed,
      LeadAgentLeadStageType.Attempted,
      LeadAgentLeadStageType.Contacted_Vendor,
      LeadAgentLeadStageType.Appraised,
      LeadAgentLeadStageType.Appointed,
    ].includes(state.lam.stagetypeid),
    lamStageIsEqualOrMoreThanListed: state => [
      LeadAgentLeadStageType.Listed,
    ].includes(state.lam.stagetypeid),
    leadStageIsLessThanUnderOffer: state => [
      LeadStageType.New,
      LeadStageType.Want_Intro,
      LeadStageType.Hot_Intro,
      LeadStageType.Appraised,
      LeadStageType.Listed,
    ].includes(state.lead.leadstageid),
    leadStageIsLessThanSold: state => [
      LeadStageType.New,
      LeadStageType.Want_Intro,
      LeadStageType.Hot_Intro,
      LeadStageType.Appraised,
      LeadStageType.Listed,
      LeadStageType.Pre_Sale,
    ].includes(state.lead.leadstageid),
    leadStageIsLessThanReviewed: state => [
      LeadStageType.New,
      LeadStageType.Want_Intro,
      LeadStageType.Hot_Intro,
      LeadStageType.Appraised,
      LeadStageType.Listed,
      LeadStageType.Pre_Sale,
      LeadStageType.Sold,
    ].includes(state.lead.leadstageid),
    lamIsListed: state => state.lam.statetypeid === LeadAgentLeadStateType.Active
      && state.lead.leadstateid === LeadStateType.Open
      && state.lam.stagetypeid === LeadAgentLeadStageType.Listed,
    lamIsSold: state => state.lam.statetypeid === LeadAgentLeadStateType.Active
      && state.lead.leadstateid === LeadStateType.Open
      && state.lead.leadstageid === LeadStageType.Sold
      && state.lam.stagetypeid === LeadAgentLeadStageType.Listed,
    lamIsUnderOffer: state => state.lam.statetypeid === LeadAgentLeadStateType.Active
      && state.lead.leadstateid === LeadStateType.Open
      && state.lead.leadstageid === LeadStageType.Pre_sale
      && state.lam.stagetypeid === LeadAgentLeadStageType.Listed,
    lamIsReviewed: state => state.lam.statetypeid === LeadAgentLeadStateType.Active
      && state.lead.leadstateid === LeadStateType.Open
      && state.lead.leadstageid === LeadStageType.Reviewed
      && state.lam.stagetypeid === LeadAgentLeadStageType.Listed,
    lamIsPreListed: state => [
      LeadAgentLeadStageType.Shown_To_Vendor,
      LeadAgentLeadStageType.Shortlisted,
      LeadAgentLeadStageType.Referred,
      LeadAgentLeadStageType.Viewed,
      LeadAgentLeadStageType.Attempted,
      LeadAgentLeadStageType.Contacted_Vendor,
      LeadAgentLeadStageType.Appraised,
      LeadAgentLeadStageType.Appointed,
    ].includes(state.lam.stagetypeid),
    leadIsListed: state => state.lead.leadstageid === LeadStageType.Listed,
    leadStageIsEqualOrMoreThanListed: state => [
      LeadStageType.Listed,
      LeadStageType.Pre_Sale,
      LeadStageType.Sold,
      LeadStageType.Reviewed,
    ].includes(state.lead.leadstageid),
    leadIsSold: state => state.lead.leadstageid === LeadStageType.Sold,
    leadStageIsEqualOrMoreThanUnderOffer: state => [
      LeadStageType.Pre_Sale,
      LeadStageType.Sold,
      LeadStageType.Reviewed,
    ].includes(state.lead.leadstageid),
    leadIsUnderOffer: state => state.lead.leadstageid === LeadStageType.Pre_Sale,
    leadStageIsEqualOrMoreThanSold: state => [
      LeadStageType.Sold,
      LeadStageType.Reviewed,
    ].includes(state.lead.leadstageid),
    leadIsReviewed: state => state.lead.leadstageid === LeadStageType.Reviewed,
    leadStageIsEqualOrMoreThanReviewed: state => [
      LeadStageType.Reviewed,
    ].includes(state.lead.leadstageid),
    hasListingAgreement: state => state.files.some(file => file.uploadtypeid === 1),
    hasContractOfSale: state => state.files.some(file => file.uploadtypeid === 2),
  },
}));

export default leadAgentMappingStore;
